import { render, staticRenderFns } from "./bjEdit_v2.vue?vue&type=template&id=1364d8c0&scoped=true&"
import script from "./bjEdit_v2.vue?vue&type=script&lang=js&"
export * from "./bjEdit_v2.vue?vue&type=script&lang=js&"
import style0 from "./bjEdit_v2.vue?vue&type=style&index=0&id=1364d8c0&lang=less&scoped=true&"
import style1 from "./bjEdit_v2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364d8c0",
  null
  
)

component.options.__file = "bjEdit_v2.vue"
export default component.exports